module.exports = __webpack_public_path__ + "static/media/logosiswa-clean.09b503c1.png";